import { createAction, props } from '@ngrx/store';

export enum ParnersActions {
  ParnersRequested = '[Parners] Parners Requested',
  ParnersLoaded = '[Parners] Parners Loaded',
  ParnersError = '[Parners] Parners Error'
}

export const ParnersRequested = createAction(ParnersActions.ParnersRequested);

export const ParnersLoaded = createAction(ParnersActions.ParnersLoaded,
  props<{ parners: any[] }>());

export const ParnersError = createAction(ParnersActions.ParnersError);
